"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.orderFactory = orderFactory;
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _toLower2 = _interopRequireDefault(require("lodash/toLower"));
var _dateFns = require("date-fns");
var _ar = _interopRequireDefault(require("date-fns/locale/ar"));
var _en = _interopRequireDefault(require("date-fns/locale/en"));
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _language = require("@tajawal/guest-sdk/lib/utils/language.utils");
var _hotelBooking = require("../utils/hotel-booking.utils");
var _constants2 = require("../constants");
var _bookings = require("../utils/bookings.utils");
const dateFormat = 'DD MMM YYYY';
const payLaterDateFormat = 'dddd, MMMM DD, YYYY';
const payBeforeDateFormat = 'ddd, DD MMM YYYY';
const paymentDateFormat = 'ddd, DD MMM';
const property = 'options.property.propertySearchIDResponse.propertyDetailsExtension';
const activitiesFormat = 'dddd, DD MMM';
const time = 'hh:mm';
const dateFormatHotel = 'YYYY-MM-DD';

/**
 *
 * @param order
 * @param formatPrice
 * @param language
 * @returns {{hotelCity: (*), orderNumber: *, checkIn: *, orderId: *, hotelImage: *, firstCancellationDate: *, rateInfo: {currency: *, finalRate: *}, checkOut: *, hotelName: (*), productType: *, paymentStatus: *, status: *}|{}|{tripType: *, orderNumber: *, originId: *, orderId: *, departureDate: *, destinationId: *, productType: *, arrivalDate: *, status: *}}
 */

function orderFactory(order, formatPrice, language) {
  if ((0, _isEmpty2.default)(order)) return {};
  const product = (0, _find2.default)(order.products, {
    type: _constants2.PRODUCT_TYPES.FLIGHT
  }) || (0, _find2.default)(order.products, {
    type: _constants2.PRODUCT_TYPES.HOTEL
  }) || (0, _find2.default)(order.products, {
    type: _constants2.PRODUCT_TYPES.ACCOMMODATION
  }) || (0, _find2.default)(order.products, {
    type: _constants2.PRODUCT_TYPES.ACTIVITY
  });
  if ((0, _isEmpty2.default)(product)) return {};
  const locale = language === _constants.LANGUAGE.EN ? _en.default : _ar.default;
  const checkInDate = (0, _dateFns.parse)((0, _get2.default)(product, 'options.checkInDate'));
  const stayCompleted = (0, _dateFns.isSameDay)(checkInDate) || (0, _dateFns.isAfter)(new Date(), checkInDate);
  const status = (0, _get2.default)(product, 'status', null);
  const paymentStatus = (0, _get2.default)(product, 'paymentStatus', null);
  const endUserStatus = (0, _hotelBooking.getHotelOrderEndUserStatus)({
    stayCompleted,
    paymentStatus,
    bookingStatus: status
  });

  // accommodation product specific
  const originalNameEn = (0, _get2.default)(product, `${property}.originalNameEn`);
  const originalNameAr = (0, _get2.default)(product, `${property}.originalNameAr`);
  const nameEn = (0, _get2.default)(product, `${property}.property.nameEn`);
  const nameAr = (0, _get2.default)(product, `${property}.property.nameAr`);
  const isCancelled = (0, _get2.default)(product, 'status') === _constants2.ORDER_STATUS.CANCELLED || (0, _get2.default)(product, 'status') === _constants2.ORDER_STATUS.MANUALLY_CANCELLED;
  const appearance = (0, _bookings.getBookingAppearance)(order === null || order === void 0 ? void 0 : order.displayStatus);
  const bookingTagStatus = (0, _bookings.getBookingTagStatus)(order === null || order === void 0 ? void 0 : order.displayStatus);
  if (product.type === _constants2.PRODUCT_TYPES.FLIGHT) {
    var _order$additionalData, _order$additionalData2;
    const lastLegIndex = (0, _get2.default)(product, 'options.leg', []).length - 1;
    const tripType = _constants2.TRIP_TYPE[(0, _toLower2.default)((0, _get2.default)(product, 'additionalData.searchType', ''))];
    const dayDiffFromCurrentDate = (0, _dateFns.differenceInCalendarDays)((0, _dateFns.parse)((0, _get2.default)(product, `options.leg[${lastLegIndex}].arrival`)), new Date());
    const dayDiffFromDepartureDate = (0, _dateFns.differenceInCalendarDays)((0, _dateFns.parse)((0, _get2.default)(product, `options.leg[${lastLegIndex}].departure`)), new Date());
    const isMultiPNR = order === null || order === void 0 ? void 0 : (_order$additionalData = order.additionalData) === null || _order$additionalData === void 0 ? void 0 : _order$additionalData.isMultiPNR;
    return {
      orderId: order.orderId,
      orderNumber: order.orderNumber,
      productType: product.type,
      tripType: isMultiPNR ? 'Roundtrip' : tripType,
      orderDate: (0, _dateFns.format)((0, _dateFns.parse)(order.createdAt), dateFormatHotel),
      originCountryCode: (0, _get2.default)(product, `options.leg[0].originCountry`, ''),
      destinationCountryCode: (0, _get2.default)(product, `options.leg[0].destinationCountry`, ''),
      originCityName: (0, _get2.default)(product, `options.leg[0].originCity`, ''),
      destinationCityName: (0, _get2.default)(product, `options.leg[0].destinationCity`, ''),
      originId: (0, _get2.default)(product, 'options.leg[0].originId'),
      destinationId: (0, _toLower2.default)(tripType) === 'oneway' || isMultiPNR ? (0, _get2.default)(product, `options.leg[0].destinationId`) : (0, _get2.default)(product, `options.leg[${lastLegIndex}].originId`),
      departureDate: (0, _dateFns.format)((0, _dateFns.parse)((0, _get2.default)(isMultiPNR ? order.products.filter(prod => prod.type === _constants2.PRODUCT_TYPES.FLIGHT).find(prod => prod.options.direction === 'outbound') : product, 'options.leg[0].departure')), dateFormat, {
        locale
      }),
      arrivalDate: (0, _dateFns.format)((0, _dateFns.parse)((0, _get2.default)(product, `options.leg[${lastLegIndex}].arrival`)), dateFormat, {
        locale
      }),
      returnDate: (0, _dateFns.format)((0, _dateFns.parse)((0, _get2.default)(isMultiPNR ? order.products.filter(prod => prod.type === _constants2.PRODUCT_TYPES.FLIGHT).find(prod => prod.options.direction === 'inbound') : product, `options.leg[${isMultiPNR ? 0 : lastLegIndex}].departure`)), dateFormat, {
        locale
      }),
      bookingStatus: product.status,
      isPayLater: false,
      bookingType: dayDiffFromCurrentDate >= 0 && !isCancelled ? _constants2.BOOKING_TYPES.UPCOMING : _constants2.BOOKING_TYPES.PAST,
      dayDiffFromCurrentDate,
      dayDiffFromDepartureDate,
      isCancelled,
      entityType: order === null || order === void 0 ? void 0 : (_order$additionalData2 = order.additionalData) === null || _order$additionalData2 === void 0 ? void 0 : _order$additionalData2.entityType,
      appearance,
      bookingTagStatus,
      displayStatus: order.displayStatus
    };
  }
  if (product.type === _constants2.PRODUCT_TYPES.HOTEL) {
    var _order$additionalData3, _order$additionalData4;
    const dayDiffFromCurrentDate = (0, _dateFns.differenceInCalendarDays)((0, _dateFns.parse)((0, _get2.default)(product, 'options.checkOutDate')), new Date());
    const dayDiffFromDepartureDate = (0, _dateFns.differenceInCalendarDays)((0, _dateFns.parse)((0, _get2.default)(product, 'options.checkInDate')), new Date());
    const checkIn = (0, _dateFns.format)((0, _dateFns.parse)((0, _get2.default)(product, 'options.checkInDate')), dateFormat, {
      locale
    });
    const checkOut = (0, _dateFns.format)((0, _dateFns.parse)((0, _get2.default)(product, 'options.checkOutDate')), dateFormat, {
      locale
    });
    const payBefore = (0, _dateFns.format)((0, _dateFns.parse)((0, _get2.default)(product, 'options.firstCancellationDate')), payBeforeDateFormat, {
      locale
    });
    return {
      payBefore,
      orderId: order.orderId,
      orderNumber: order.orderNumber,
      productType: product.type,
      hotelName: language === _constants.LANGUAGE.EN ? (0, _get2.default)(product, 'options.hotelNameEn') : (0, _get2.default)(product, 'options.hotelNameAr'),
      hotelCity: language === _constants.LANGUAGE.EN ? (0, _get2.default)(product, 'options.cityEn') : (0, _get2.default)(product, 'options.cityAr'),
      hotelImage: (0, _get2.default)(product, 'defaultImage.url'),
      cityEn: (0, _get2.default)(product, 'options.cityEn'),
      checkIn,
      checkOut,
      timeAndDate: {
        checkInDate: checkIn,
        checkOutDate: checkOut,
        newCheckInDate: checkIn,
        newCheckOutDate: checkOut
      },
      bookingStatus: product.status,
      isPayLater: order.paymentStatus === _constants2.PAYMENT_STATUS.PENDING,
      rateInfo: {
        finalRate: formatPrice((0, _get2.default)(order, 'totals.total', 0).toFixed(2)),
        currency: (0, _get2.default)(order, 'totals.totalCurrency')
      },
      firstCancellationDate: (0, _dateFns.format)((0, _dateFns.parse)((0, _get2.default)(product, 'options.firstCancellationDate')), payLaterDateFormat, {
        locale
      }),
      paymentDate: (0, _dateFns.format)((0, _dateFns.parse)((0, _get2.default)(product, 'options.firstCancellationDate')), paymentDateFormat, {
        locale
      }),
      supplierFirstCancellationDate: (0, _dateFns.format)((0, _dateFns.parse)((0, _get2.default)(product, 'options.supplierFirstCancellationDate')), payLaterDateFormat, {
        locale
      }),
      bookingType: dayDiffFromCurrentDate >= 0 && !isCancelled ? _constants2.BOOKING_TYPES.UPCOMING : _constants2.BOOKING_TYPES.PAST,
      dayDiffFromCurrentDate,
      dayDiffFromDepartureDate,
      isCancelled,
      endUserStatus,
      entityType: order === null || order === void 0 ? void 0 : (_order$additionalData3 = order.additionalData) === null || _order$additionalData3 === void 0 ? void 0 : _order$additionalData3.entityType,
      saleId: order === null || order === void 0 ? void 0 : (_order$additionalData4 = order.additionalData) === null || _order$additionalData4 === void 0 ? void 0 : _order$additionalData4.saleId,
      appearance,
      bookingTagStatus,
      image: (0, _get2.default)(product, 'defaultImage.url'),
      name: language === _constants.LANGUAGE.EN ? (0, _get2.default)(product, 'options.hotelNameEn') : (0, _get2.default)(product, 'options.hotelNameAr'),
      city: language === _constants.LANGUAGE.EN ? (0, _get2.default)(product, 'options.cityEn') : (0, _get2.default)(product, 'options.cityAr'),
      displayStatus: order.displayStatus,
      originProduct: product
    };
  }
  if (product.type === _constants2.PRODUCT_TYPES.ACCOMMODATION) {
    var _order$additionalData5;
    const dayDiffFromCurrentDate = (0, _dateFns.differenceInCalendarDays)((0, _dateFns.parse)((0, _get2.default)(product, 'options.property.propertySearchIDResponse.checkOut')), new Date());
    const dayDiffFromDepartureDate = (0, _dateFns.differenceInCalendarDays)((0, _dateFns.parse)((0, _get2.default)(product, 'options.property.propertySearchIDResponse.checkIn')), new Date());
    const checkInAccommodation = (0, _get2.default)(product, 'options.property.propertySearchIDResponse.checkIn');
    const checkOutAccommodation = (0, _get2.default)(product, 'options.property.propertySearchIDResponse.checkOut');
    return {
      orderId: order.orderId,
      orderNumber: order.orderNumber,
      productType: product.type,
      bookingStatus: product.status,
      bookingType: dayDiffFromCurrentDate >= 0 && !isCancelled ? _constants2.BOOKING_TYPES.UPCOMING : _constants2.BOOKING_TYPES.PAST,
      isCancelled,
      endUserStatus,
      thumbnailImageUrl: (0, _get2.default)(product, `${property}.thumbnailImageUrl`),
      propertyName: (0, _language.localize)({
        source: {
          nameAr,
          nameEn
        },
        key: 'name',
        language
      }),
      propertyOriginalName: (0, _language.localize)({
        source: {
          originalNameEn,
          originalNameAr
        },
        key: 'originalName',
        language
      }),
      location: {
        areaEn: (0, _get2.default)(product, `${property}.location.area.nameEn`),
        areaAr: (0, _get2.default)(product, `${property}.location.area.nameAr`)
      },
      timeAndDate: {
        checkInDate: checkInAccommodation,
        newCheckInDate: (0, _dateFns.format)((0, _dateFns.parse)(checkInAccommodation), dateFormat, {
          locale
        }),
        checkOutDate: checkOutAccommodation,
        newCheckOutDate: (0, _dateFns.format)((0, _dateFns.parse)(checkOutAccommodation), dateFormat, {
          locale
        }),
        checkInBeginTime: (0, _get2.default)(product, `${property}.checkinBeginTime`),
        checkOutBeginTime: (0, _get2.default)(product, `${property}.checkoutBeginTime`),
        checkInEndTime: (0, _get2.default)(product, `${property}.checkinEndTime`),
        checkOutEndTime: (0, _get2.default)(product, `${property}.checkoutEndTime`)
      },
      dayDiffFromCurrentDate,
      dayDiffFromDepartureDate,
      entityType: order === null || order === void 0 ? void 0 : (_order$additionalData5 = order.additionalData) === null || _order$additionalData5 === void 0 ? void 0 : _order$additionalData5.entityType,
      appearance,
      bookingTagStatus,
      image: (0, _get2.default)(product, `${property}.thumbnailImageUrl`),
      name: (0, _language.localize)({
        source: {
          nameAr,
          nameEn
        },
        key: 'name',
        language
      }),
      city: language === _constants.LANGUAGE.EN ? (0, _get2.default)(product, `${property}.location.area.nameEn`) : (0, _get2.default)(product, `${property}.location.area.nameAr`),
      displayStatus: order.displayStatus,
      isPayLater: false
    };
  }
  if (product.type === _constants2.PRODUCT_TYPES.ACTIVITY) {
    var _order$additionalData6;
    const dayDiffFromCurrentDate = (0, _dateFns.differenceInCalendarDays)((0, _dateFns.parse)((0, _get2.default)(product, 'options.activityOrderDetail.checkIn')), new Date());
    const dayDiffFromDepartureDate = dayDiffFromCurrentDate;
    return {
      orderId: order.orderId,
      orderNumber: order.orderNumber,
      productType: product.type,
      bookingStatus: product.status,
      name: (0, _get2.default)(product, 'options.activityOrderDetail.activity.title'),
      city: language === _constants.LANGUAGE.EN ? (0, _get2.default)(product, 'options.activityOrderDetail.activity.cityDtl.nameEn') : (0, _get2.default)(product, 'options.activityOrderDetail.activity.cityDtl.nameAr'),
      bookingTagStatus,
      isCancelled,
      image: (0, _get2.default)(product, 'options.activityOrderDetail.activity.thumbnail.url'),
      bookingType: dayDiffFromCurrentDate >= 0 && !isCancelled ? _constants2.BOOKING_TYPES.UPCOMING : _constants2.BOOKING_TYPES.PAST,
      entityType: order === null || order === void 0 ? void 0 : (_order$additionalData6 = order.additionalData) === null || _order$additionalData6 === void 0 ? void 0 : _order$additionalData6.entityType,
      timeAndDate: {
        newCheckInDate: (0, _dateFns.format)((0, _dateFns.parse)((0, _get2.default)(product, 'options.activityOrderDetail.checkIn')), activitiesFormat, {
          locale
        }),
        time: (0, _dateFns.format)((0, _dateFns.parse)((0, _get2.default)(product, 'options.activityOrderDetail.checkIn')), time, {
          locale
        })
      },
      displayStatus: order.displayStatus,
      dayDiffFromCurrentDate,
      dayDiffFromDepartureDate,
      isPayLater: false
    };
  }
  return {};
}